export default __webpack_public_path__ + "static/media/features-translate.985c2d2a.svg";